"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMinMaxPagesForBookProject;
const Product_1 = require("../../models/Product");
/**
 * Indicates the minimum and maximum number of pages the project is allowed to have, as defined by the HAMMER template.
 *
 * @returns Array with two values: first is the min, second is the max
 */
function getMinMaxPagesForBookProject(template, hammerCategory) {
  // For spread books, the min\max values represent spreads, not individual pages. So
  // multiply the values by 2.
  if ((0, Product_1.isSpreadBooksCategory)(hammerCategory)) {
    return [template.pages.min * 2, template.pages.max * 2];
  } else {
    return [template.pages.min, template.pages.max];
  }
}